import { IAuthAccount } from "../src/taskpane/interfaces/IAuthTokenResultDto";
import { apiClientError, apiLog } from "../src/taskpane/services/ApiService";
import AuthModule from "./AuthModule";

const tryStringify = (value: any): string => {
    let stringifiedObject: string;
    try {
        stringifiedObject = JSON.stringify(value);
    } catch (error) {
        // Ignore
    }
    return stringifiedObject ?? "";
}

export const logger = async (e: Error, filePath: string, additionalData?: string) => {
    console.error(e);
    let account: IAuthAccount;
    let hostType: string;
    let path: string = filePath;
    try {
        if (typeof Office !== "undefined" && typeof Office.context?.diagnostics?.host !== "undefined") {
            switch (Office.context?.diagnostics?.host) {
                case Office.HostType.Word:
                    hostType = "Word";
                    break;
                case Office.HostType.Excel:
                    hostType = "Excel";
                    break;
                case Office.HostType.PowerPoint:
                    hostType = "PowerPoint";
                    break;
                case Office.HostType.Outlook:
                    hostType = "Outlook";
                    break;
                default:
                    break;
            }
        }

        account = await AuthModule.getAccount();
    } catch (err) {
        // Ignore
    }

    let errorMessage: string = (e?.stack ? e.stack : e?.message) + (additionalData ? ` - ${additionalData}` : "");

    if (e && (errorMessage === undefined || !errorMessage)) {
        errorMessage = tryStringify(e);
    }

    const clientError = {
        error: errorMessage || tryStringify(e),
        filePath: path,
        accountId: account?.username ?? account?.accountId,
        browser: navigator?.userAgent,
        hostType: hostType ?? "Other",
    }

    try {
        await apiClientError(clientError);
    } catch (error) {
        console.error("Error on log save: ", error);
    }
}

export const logMessage = async (message: string, type?: string) => {
    try {
        const account: IAuthAccount = await AuthModule.getAccount();
        await apiLog(message, account, type);
    } catch (error) {
        console.error("Error on log message: ", error);
    }
}